import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "goback",
  "use": "goback-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"goback\"><path d=\"M12 4H7.48L10.6.83 9.76 0 5.69 4.08a.59.59 0 000 .83L9.76 9l.84-.83-3-3H12A8.85 8.85 0 113.16 14H2A10 10 0 1012 4z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol